export default __webpack_public_path__ + "static/media/logo-aorus.db3e2332.svg";